module.exports = __webpack_public_path__ + "img/powerIcon.9cae5643.png";